import { DeviceFromApiType } from "@/types"

import { apiFetch } from "../utils"
const billingUrl = `himo-billing/`
export async function getAllUserDevices(): Promise<DeviceFromApiType[]> {
  const response = await apiFetch(`${billingUrl}get-all-meter-reader-device/`)
  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }
  return response.json()
}
